import { render } from "./ManifestosList.vue?vue&type=template&id=5388ccac"
import script from "./ManifestosList.vue?vue&type=script&lang=js"
export * from "./ManifestosList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__